import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './summarybox.css';
import FormControl from '@mui/material/FormControl';
import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MenuIcon from '@mui/icons-material/Menu';
import Collapse from '@mui/material/Collapse';
import numeral from 'numeral';
import Link from '@mui/material/Link';
import SummaryBoxLogic from './SummaryBoxLogic';
import Tooltip from '@mui/material/Tooltip';

const SummaryBox = (props) => {
  const {expanded,floodMapCount,evidenceString,socialMediaCount,weatherCount,newsCount,aPCount,aSum,vPCount,
    vSum,nonPCount,nonSum,addressArray,handleExpandClick,showFema,showLogos,alignment,handleChange} = SummaryBoxLogic(props);

  return (
    <Card id="summary-box-container">
        <CardContent style={{marginBottom:-25}}>
          <div style={{display:'flex',justifyContent:'space-between'}}>
            <h4 id="summary-box-address">{addressArray[0]},{addressArray[1]}<br/>{addressArray[2]},{addressArray[3]}</h4>
            <MenuIcon 
              style={{cursor:'pointer'}}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more" />
          </div>
        </CardContent>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
      <p className="twenty" style={{fontSize:'x-small',color:'red',marginLeft:5}} align='center'>Click on the menu button on top-right to minimize this box.</p>
        <CardContent>
          
          <p className="box-text"  style={{marginTop:-15}}>{evidenceString}</p><br></br>
          
          
          <ToggleButtonGroup variant="contained" id="button-group" size="small" fullWidth exclusive color='success' value={alignment} onChange={handleChange}>
            
            
              <ToggleButton value="Terra Cover Dataset"  onClick={() => showLogos()}>
                
                  <p className="toggle-button">Flood History</p>
                  
                
                </ToggleButton>
              
            
            <ToggleButton value="FEMA Claims Dataset"  onClick={() => showFema()}><p className="toggle-button">FEMA Claims History</p></ToggleButton>
          
          
          </ToggleButtonGroup>
          
          
          <TableContainer id="logo-table"  component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow style={{backgroundColor:"#203b11ff"}}>
                  
                  <TableCell style={{color:"white"}} colSpan={3}>
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Flood History around a property contains floods maps, geo-tagged social media, news and weather reports. <br></br> <br></br>Flood maps are shown as blue on the map. Geo-tagged tweets, news, and weather reports are shown using their respective icons.</div>} enterTouchDelay={0}>
                    <div>
                    <span className="table-text">FLOOD HISTORY | </span>
                    <span className="table-details"><u>See Details</u></span>
                    </div>
                  </Tooltip>

               

                  </TableCell>
                  
                  
                  <TableCell align="right">
                    <FormControl size="small">
                    </FormControl>
                  
                  </TableCell>
                </TableRow>
              </TableHead>
            
            <TableBody>
              <TableRow >
                
                
                
                <TableCell align="center" className="table-text" style={{width:'10%'}}></TableCell >

                
                
                <TableCell align="left" className="table-text" style={{width:'40%'}}>
                <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Modeled flood extents integrated from Harris Country Flood Control District database (https://www.harriscountyfws.org/). <br></br> <br></br> Disclaimer (taken from https://www.harriscountyfws.org/): The Harris County Flood Control District (HCFCD) provides information via this website as a public service. While HCFCD makes every effort to ensure information is up-to-date, accurate and complete, HCFCD makes no representations, guarantees, or warranties as to the availability, accuracy, completeness, currency or suitability of the information provided via this website. HCFCD specifically disclaims any and all liability for any claims or damages that may result from providing the website or the information it contains. All liability with respect to actions taken or not taken based on the contents of this site is hereby expressly disclaimed.</div>} enterTouchDelay={0} placement="bottom-end">
                  <div>
                  <img alt="icon" style={{marginLeft:'5px'}} src={require('../../../assets/imagery.png')}/><span style={{marginLeft:'5px'}} className="count">{floodMapCount}</span> <span style={{marginLeft:'20px'}} className="count">Flood Maps</span>
                  </div>
                  </Tooltip>
                </TableCell>

                
                
                <TableCell align="right" className="table-text" style={{width:'50%',marginLeft:'15px'}}>
                  <FormControl>
                    {props.selectedEvent ? (
                      <Select
                        variant="filled"
                        value={props.selectedEvent}
                        options={props.events}
                        menuPosition={'fixed'}
                        onChange={(e) => props.setSelectedEvent(e)}
                      />
                    ) : (null)}
                  </FormControl>
                </TableCell>
              </TableRow>

            </TableBody>
            </Table>
          </TableContainer>

          <TableContainer id="logo-table2"  component={Paper}>
            <Table size="small">
              <TableBody>
                <TableRow>
                <TableCell align="center" className="table-text" style={{width:'10%'}}></TableCell >
                
                  <TableCell align="left" className="table-text" style={{width:'33%'}}>
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Geo-tagged tweets</div>} enterTouchDelay={0} placement="top-end">
                    <div>
                    <img  alt="icon" style={{marginLeft:'5px'}} src={require('../../../assets/twitter.png')} onClick={() => props.setSelectedSource('twitter')} /> <span style={{marginLeft:'5px'}} className="count"> {socialMediaCount}</span> 
                    </div>
                  </Tooltip>
                  </TableCell >
                  
                  <TableCell align="left" className="table-text" style={{width:'33%'}}>
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Geo-tagged news articles</div>} enterTouchDelay={0} placement="top-end">
                    <div>
                    <img alt="icon" src={require('../../../assets/news.png')}/><span style={{marginLeft:'5px'}} className="count">{newsCount}</span>
                    </div>
                    </Tooltip>
                  </TableCell >
                
                  <TableCell align="left" className="table-text" style={{width:'33%'}}>
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Geo-tagged weather reports</div>} enterTouchDelay={0} placement="top-end">
                    <div>
                    <img alt="icon" src={require('../../../assets/weather.png')}/><span style={{marginLeft:'5px'}} className="count">{weatherCount}</span>
                    </div>
                    </Tooltip>
                  </TableCell>

                  <TableCell align="center" className="table-text" style={{width:'40%'}}>
     
                  </TableCell>
                
                </TableRow>

              </TableBody>
            </Table>
          </TableContainer>
                
          <TableContainer style={{marginTop:10}} id="fema-table"  component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow style={{backgroundColor:"#203b11ff"}}>
                  <TableCell style={{color:"white"}}  colSpan={3}>
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Federal Emergency Management Agency (FEMA), OpenFEMA Dataset: Disaster Declarations Summaries - v2. Retrieved from https://www.fema.gov/openfema-data-page/disaster-declarations-summaries-v2 on August 19, 2021, 12:34 PM EST.<br/><br/>This product uses the FEMA OpenFEMA API, but is not endorsed by FEMA. The Federal Government or FEMA cannot vouch for the data or analyses derived from these data after the data have been retrieved from the Agency's website(s).</div>} placement="top-end">
                  <div>
                    <span className="table-text">FEMA CLAIMS HISTORY | </span>
                    <span className="table-details"><u>See Details</u></span>
                    </div>
                  </Tooltip>
                  </TableCell>
                </TableRow>
            
                <TableRow>
                  <TableCell align="left"  ><p className="table-text">Flood Zone</p></TableCell>
                  <TableCell align="left"  ><p className="table-text">Claims</p></TableCell>
                  <TableCell align="left"  ><p className="table-text">Average Claim</p></TableCell>
                </TableRow>
              </TableHead>
            
              <TableBody>
                <TableRow>
                  <TableCell align="center" >
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Regions where flood insurance is compulsory by law.</div>} enterTouchDelay={0} placement="bottom-end">
                    <p className="table-text">Mandatory</p>
                  </Tooltip>
                  </TableCell >
                  <TableCell align="center" >
                    <p className="table-text">{+aPCount + +vPCount}</p>
                  </TableCell >
                  <TableCell align="center" >
                    <p className="table-text">{'$'+numeral((+aSum + +vSum)/(+aPCount + +vPCount)).format('0.00a')}</p>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell align="center" >
                  <Tooltip disableInteractive title={<div style={{fontSize:'13px'}}>Regions where flood insurance is optional.</div>} enterTouchDelay={0} placement="bottom-end">
                    <p className="table-text">Non-Mandatory</p>
                    </Tooltip>
                  </TableCell >
                  <TableCell align="center" >
                    <p className="table-text">{Math.trunc(nonPCount)}</p>
                  </TableCell >
                  <TableCell align="center" >
                    <p className="table-text">{'$'+numeral(nonSum/nonPCount).format('0.00a')}</p>
                  </TableCell >
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <br></br>
          

              <Link className='search-text' href="https://terracover.ai/flood-history">Search for another property</Link>

        </CardContent>
      </Collapse>
    </Card>

    
   
  ) 
}

export default SummaryBox